"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendEventRemoveFromCart = exports.sendEventAddToCart = exports.sendItemEventInCartOld = exports.sendEventViewCart = exports.sendAddToCartEventFromShop = exports.sendEvent = exports.GaMethodValue = exports.GaDefaultEvent = void 0;
var GaDefaultEvent;
(function (GaDefaultEvent) {
    GaDefaultEvent["addToCart"] = "add_to_cart";
    GaDefaultEvent["removeFromCart"] = "remove_from_cart";
})(GaDefaultEvent = exports.GaDefaultEvent || (exports.GaDefaultEvent = {}));
var GaMethodValue;
(function (GaMethodValue) {
    GaMethodValue["shopSection"] = "shop_section";
    GaMethodValue["shopAll"] = "shop_all";
    GaMethodValue["cartUpsell"] = "cart_upsell";
    GaMethodValue["cartUpdateQuantity"] = "cart_update_quantity";
})(GaMethodValue = exports.GaMethodValue || (exports.GaMethodValue = {}));
var sendEvent = function (eventName) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: eventName,
    });
};
exports.sendEvent = sendEvent;
var sendAddToCartEventFromShop = function (product, variant) {
    sendItemEventInCart(product, variant, GaDefaultEvent.addToCart, GaMethodValue.shopSection);
};
exports.sendAddToCartEventFromShop = sendAddToCartEventFromShop;
var sendItemEventInCart = function (product, variant, eventName, method) {
    var productId = product.id.split('/')[4];
    var variantId = variant.id.split('/')[4];
    var itemId = "shopify_US_".concat(productId, "_").concat(variantId);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: eventName,
        ecommerce: {
            ecomm_prodid: [itemId],
            ecomm_totalvalue: variant.price.amount,
            ecomm_pagetype: 'cart',
            method: method,
            value: variant.price.amount,
            currency: 'USD',
            items: [
                {
                    item_id: itemId,
                    item_name: "".concat(product.title).concat(variant.title === 'Default Title' ? '' : ' - ' + variant.title),
                    // item_brand: product.vendor, // perhaps no need to pass
                    item_category: '',
                    item_variant: variant.title !== 'Default Title' ? variant.title : null,
                    price: +variant.price.amount,
                    quantity: 1,
                },
            ],
        },
    });
};
var sendEventViewCart = function (cart) {
    var cartTransformedForGA = cart.items.map(function (item) {
        return {
            item_id: "shopify_US_".concat(item.product_id, "_").concat(item.variant_id),
            item_name: "".concat(item.product_title).concat(item.variant_title == null ? '' : ' - ' + item.variant_title),
            item_brand: item.vendor,
            item_category: '',
            item_variant: item.variant_title == null ? null : item.variant_title,
            price: item.price / 100,
            quantity: item.quantity,
        };
    });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'view_cart',
        ecommerce: {
            currency: 'USD',
            items: cartTransformedForGA,
            value: cart.total_price / 100,
        },
    });
};
exports.sendEventViewCart = sendEventViewCart;
// TODO: used in ShopALlProductCart.tsx.
// once shop all is converted to GraphQL, delete this func
var sendItemEventInCartOld = function (product, variant, eventName, method) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: eventName,
        ecommerce: {
            ecomm_prodid: ["shopify_US_".concat(product.id, "_").concat(variant.id)],
            ecomm_totalvalue: variant.price / 100,
            ecomm_pagetype: 'cart',
            method: method,
            value: variant.price / 100,
            currency: 'USD',
            items: [
                {
                    item_id: "shopify_US_".concat(product.id, "_").concat(variant.id),
                    item_name: "".concat(product.title).concat(variant.title === 'Default Title' ? '' : ' - ' + variant.title),
                    item_brand: product.vendor,
                    item_category: '',
                    item_variant: variant.title !== 'Default Title' ? variant.title : null,
                    price: variant.price / 100,
                    quantity: 1,
                },
            ],
        },
    });
};
exports.sendItemEventInCartOld = sendItemEventInCartOld;
var sendItemEventInCartV3 = function (product, variant, eventName, method) {
    var productId = product.id.split('/')[4];
    var variantId = variant.id.split('/')[4];
    var itemId = "shopify_US_".concat(productId, "_").concat(variantId);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: eventName,
        ecommerce: {
            ecomm_prodid: [itemId],
            ecomm_totalvalue: Number(variant.price.amount),
            ecomm_pagetype: 'cart',
            method: method,
            value: Number(variant.price.amount),
            currency: 'USD',
            items: [
                {
                    item_id: itemId,
                    item_name: "".concat(product.title).concat(variant.title === 'Default Title' ? '' : ' - ' + variant.title),
                    // item_brand: product.vendor, // perhaps no need to pass
                    item_category: '',
                    item_variant: variant.title !== 'Default Title' ? variant.title : null,
                    price: Number(variant.price.amount),
                    quantity: 1,
                },
            ],
        },
    });
};
var sendEventAddToCart = function (product, variant, method) {
    sendItemEventInCartV3(product, variant, GaDefaultEvent.addToCart, method);
};
exports.sendEventAddToCart = sendEventAddToCart;
var sendEventRemoveFromCart = function (product, variant, method) {
    sendItemEventInCartV3(product, variant, GaDefaultEvent.removeFromCart, method);
};
exports.sendEventRemoveFromCart = sendEventRemoveFromCart;
